module.exports = __webpack_public_path__ + "8e0d3203debef0a8e15053100b97690e.png";